/* CTR B2 — continuous gradient across consecutive sections.
   Wraps the section that carries [data-b2-gradient] plus the next
   (span-1) sibling sections in a single container and paints the
   gradient as that container's background. The sections are
   transparent, so one seamless gradient shows behind all of them. */
(function () {
  function wrap(band) {
    var start = band.closest('.shopify-section');
    if (!start) return;
    var grad = band.getAttribute('data-gradient');

    // Already wrapped — just refresh the background and bail.
    if (start.parentElement && start.parentElement.classList.contains('ctr-b2-gradient-wrap')) {
      if (grad) start.parentElement.style.background = grad;
      band.style.display = 'none';
      return;
    }

    var parent = start.parentElement;
    if (!parent) return;

    var span = parseInt(band.getAttribute('data-span') || '1', 10);
    var sections = [start];
    var node = start;
    while (sections.length < span && node.nextElementSibling) {
      node = node.nextElementSibling;
      if (node.classList && node.classList.contains('shopify-section')) sections.push(node);
    }

    var box = document.createElement('div');
    box.className = 'ctr-b2-gradient-wrap';
    if (grad) box.style.background = grad;
    parent.insertBefore(box, start);
    sections.forEach(function (s) { box.appendChild(s); });

    band.style.display = 'none';
  }

  function run() {
    document.querySelectorAll('[data-b2-gradient]').forEach(wrap);
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
})();
